import { pickBy, identity, omit } from 'lodash';
import { isSSR } from 'wix-rich-content-common';
function paramsToBiFields(essentials) {
    const { bsi, metaSiteId: msid, visitorId: _visitorId, appId: _appId, instanceId: _instanceId, siteOwnerId: _siteOwnerId, } = essentials;
    return pickBy({ bsi, msid, _visitorId, _appId, _instanceId, _siteOwnerId }, identity);
}
export class RicosBILogger {
    constructor({ logger, webBiLogger, genericParams, essentials = {} }) {
        if (logger) {
            this.newLoggerConfig = { logger, genericParams: omit(genericParams, 'msid') };
            return;
        }
        if (!isSSR()) {
            const biLoggerPromise = Promise.resolve(webBiLogger ||
                import(/* webpackChunkName: "wix-ricos-bi-logger-fallback" */ '@wix/web-bi-logger'));
            this.oldLogger = biLoggerPromise.then(result => {
                // for esbuild consumers building esm bundle https://github.com/evanw/esbuild/issues/566#issuecomment-846707879 commonjs lazy chunks get double wrapped
                // @ts-expect-error - ignore
                const biLogger = result.default?.default ? result.default : result;
                return biLogger
                    .factory()
                    .updateDefaults({ ...genericParams, ...paramsToBiFields(essentials) })
                    .logger();
            });
        }
    }
    log(func, params) {
        if (this.newLoggerConfig) {
            const logObject = func(params);
            const { params: eventParams, ...rest } = logObject;
            this.newLoggerConfig.logger.report?.({
                params: { ...this.newLoggerConfig.genericParams, ...eventParams },
                ...rest,
            });
        }
        else if (this.oldLogger) {
            this.oldLogger.then(logger => logger.report(func(params)));
        }
        else {
            console.error(`[RicosBILogger.ts:log] RicosBILogger was not initialized`);
        }
    }
}
//# sourceMappingURL=RicosBILogger.js.map